import { render, staticRenderFns } from "./DatatableTransparencyTypes.vue?vue&type=template&id=cf520186&scoped=true&"
import script from "./DatatableTransparencyTypes.vue?vue&type=script&lang=js&"
export * from "./DatatableTransparencyTypes.vue?vue&type=script&lang=js&"
import style0 from "./DatatableTransparencyTypes.vue?vue&type=style&index=0&id=cf520186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf520186",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
